import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Save } from 'lucide-react';

const defaultSettings = [
  { key: 'phone', label: 'Telefon', value: '' },
  { key: 'email', label: 'Email', value: '' },
  { key: 'whatsapp', label: 'WhatsApp číslo', value: '' },
  { key: 'instagram', label: 'Instagram URL', value: '' },
  { key: 'facebook', label: 'Facebook URL', value: '' },
];

const SettingsAdmin = () => {
  const [settings, setSettings] = useState(defaultSettings);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      const { data } = await supabase.from('site_settings').select('*');
      if (data) {
        setSettings(prev => prev.map(s => {
          const found = data.find(d => d.key === s.key);
          return found ? { ...s, value: found.value } : s;
        }));
      }
    };
    fetchSettings();
  }, []);

  const save = async () => {
    setSaving(true);
    for (const s of settings) {
      const { data: existing } = await supabase.from('site_settings').select('id').eq('key', s.key).maybeSingle();
      if (existing) {
        await supabase.from('site_settings').update({ value: s.value }).eq('key', s.key);
      } else {
        await supabase.from('site_settings').insert({ key: s.key, value: s.value });
      }
    }
    toast.success('Nastavení uloženo!');
    setSaving(false);
  };

  return (
    <div>
      <h1 className="text-4xl tracking-wider text-foreground mb-8" style={{ fontFamily: 'Bebas Neue' }}>
        Nastavení
      </h1>

      <div className="max-w-lg space-y-4">
        {settings.map((s) => (
          <div key={s.key}>
            <label className="text-sm text-muted-foreground mb-1 block">{s.label}</label>
            <Input
              value={s.value}
              onChange={(e) => setSettings(prev => prev.map(p => p.key === s.key ? { ...p, value: e.target.value } : p))}
              className="bg-card border-border"
            />
          </div>
        ))}
        <Button onClick={save} disabled={saving}>
          <Save size={16} /> {saving ? 'Ukládám...' : 'Uložit'}
        </Button>
      </div>
    </div>
  );
};

export default SettingsAdmin;
